import { GetV1SelfDeclarationPaginatedHistoryParams } from 'api/generated/models';
import { Dispatch, SetStateAction, useEffect } from 'react';

interface PaginatedData {
    totalCount: number | undefined;
}

const usePaginationControl = (
    paginatedData: PaginatedData | undefined,
    pageSize: number,
    setHistoryParams: Dispatch<
        SetStateAction<GetV1SelfDeclarationPaginatedHistoryParams>
    >,
    pageNum: number
) => {
    useEffect(() => {
        const maxPageNum =
            paginatedData && paginatedData.totalCount !== undefined
                ? Math.ceil(paginatedData.totalCount / pageSize)
                : null;

        if (pageNum <= 0 || !pageNum) {
            setHistoryParams((prevParams) => ({
                ...prevParams,
                pageNumber: 1,
            }));
        } else if (paginatedData && maxPageNum && pageNum > maxPageNum) {
            setHistoryParams((prevParams) => ({
                ...prevParams,
                pageNumber: maxPageNum,
            }));
        }
    }, [paginatedData, pageSize, setHistoryParams, pageNum]);
};

export default usePaginationControl;
